import React from 'react';

interface IExperienceTagProps {
  active?: boolean;
  style?: React.CSSProperties;
}


export const ExperienceTag = (props: IExperienceTagProps) => {
  const { active, style } = props;
  return <div style={style}>
  <span style={active ? { background: '#5C9DFF', color: '#fff' } : undefined} className={'ml-[4px] rounded-[2px] px-[2px] py-[2px] text-[#4A5970] bg-[#EDF1F7] text-[10px] experience-tag-active-hover'}>体验</span>
</div>;
};
